// extracted by mini-css-extract-plugin
export var bigGrid = "media-module--bigGrid--be234";
export var hideGrid = "media-module--hideGrid--cebf4";
export var hidePreview = "media-module--hidePreview--78c9c";
export var imageMedia = "media-module--imageMedia--d0f87";
export var imageWrapper = "media-module--imageWrapper--e2946";
export var innerVideoWrap = "media-module--innerVideoWrap--346db";
export var marginTop = "media-module--marginTop--17542";
export var moveLeft = "media-module--moveLeft--8eed5";
export var playButton = "media-module--playButton--f0695";
export var playButtonOffset = "media-module--playButtonOffset--e7f68";
export var previewImage = "media-module--previewImage--86169";
export var previewWrapper = "media-module--previewWrapper--2c35f";
export var smallGrid = "media-module--smallGrid--542c3";
export var videoWrapper = "media-module--videoWrapper--1fec6";